import { CardPaymentProviderName } from '@nemuru-eng/js-api-client';

export const SinglePaymentProviderIds = {
  [CardPaymentProviderName.COMERCIA]: 'c31c847c-631b-477a-925f-ce2e06ea6d52',
  // [CardPaymentProviderName.ADYEN]: 'cc3fbfdc-7fbb-4ba7-a6f2-f415506c5d44',
  // [CardPaymentProviderName.STRIPE]: 'c9592dd0-b226-4055-b0b4-fc99a0256eb0',
};
